import MasagePage from "./MasagePage";

export default MasagePage;
